import React, { Component } from "react";
import logo from "./../../assets/images/logo.png"
const FullScreenHeader = () => {
    return (
        <div>
            <img src={logo} height="40" width="150" style={{ paddingLeft: "13px" }}></img>
        </div>
    );
}
export default FullScreenHeader;